import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { checkVerificationCode, checkVerificationCodeLive } from '../../../modules/validators';
import Button from '../../common/Button';
import TextField from '../../common/TextField';

export class VerificationCodeEntry extends Component {
  constructor(props) {
    super(props);

    this.handleVerificationCodeChange = this.handleVerificationCodeChange.bind(this);
    this.handleRestartLoginProcess = this.handleRestartLoginProcess.bind(this);
    this.handleResendVerificationCode = this.handleResendVerificationCode.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      verificationCode: '',
      validationErrors: [],
      submitDisabled: true
    };
  }

  componentWillReceiveProps(nextProps) {
    const { externalErrors } = nextProps;
    if (externalErrors && externalErrors.verificationCode) {
      this.setState({
        verificationCode: '',
        validationErrors: [externalErrors.verificationCode],
        submitDisabled: true
      });
    } else {
      this.setState({
        validationErrors: [],
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const { verificationCode } = this.state;
    const { mobileNumber, submit } = this.props;
    const errors = checkVerificationCode(verificationCode);
    const isValid = errors.length === 0;

    this.setState({
      validationErrors: (!isValid) ? [errors[0]] : []
    });

    if (!isValid) {
      return;
    }

    submit({
      mobileNumber,
      verificationCode
    });
  }

  handleVerificationCodeChange(event) {
    const {
      currentTarget: {
        value
      }
    } = event;
    const errors = checkVerificationCodeLive(value);
    const submitDisabled = checkVerificationCode(value).length !== 0;

    this.setState({
      verificationCode: value,
      validationErrors: (errors.length) ? [errors[0]] : [],
      submitDisabled
    });
  }

  handleRestartLoginProcess() {
    this.props.incorrectNumber();
    this.props.restartLoginProcess();
  }

  handleResendVerificationCode() {
    const { mobileNumber, resendVerificationCode } = this.props;

    resendVerificationCode({ mobileNumber });
  }

  render() {
    const { verificationCode, validationErrors, submitDisabled } = this.state;
    const { mobileNumber } = this.props;

    return (
      <div className="verification-code-entry">
        <div className="container--fixed">
          <p className="verification-code-entry__header">
            Thank you
          </p>
          <p className="verification-code-entry__paragraph">
            If you have a registered Plus card, we're texting a verification code to:
          </p>
          <p className="verification-code-entry__header2">
            {mobileNumber}
            <br />
          </p>
          <p className="verification-code-entry__paragraph">
            <span
              className="verification-code-entry__link"
              onClick={this.handleRestartLoginProcess}
            >
              Incorrect number? Try again.
            </span>
          </p>
          <p className="verification-code-entry__header2 verification-code-entry__header2--spaced">
            Enter your 4-digit verification code
          </p>
          <form className="verification-code-entry__form" onSubmit={this.handleSubmit}>
            <TextField
              type="tel"
              hintText="e.g. 4123"
              value={verificationCode}
              onChange={this.handleVerificationCodeChange}
              className="verification-code-entry__input"
              errors={validationErrors}
              maxLength={4}
            />
            <Button
              className="verification-code-entry__track-btn"
              disabled={submitDisabled}
              onClick={this.handleSubmit}
            >
              Submit
            </Button>
          </form>
          <p className="verification-code-entry__header2">
            No verification code?
          </p>
          <p className="verification-code-entry__paragraph">
            It can take up to 5 minutes to arrive. If you’re still waiting, request another:
          </p>
          <span
            className="verification-code-entry__link"
            onClick={this.handleResendVerificationCode}
          >
            Resend
          </span>
        </div>
      </div>
    );
  }
}

VerificationCodeEntry.propTypes = {
  submit: PropTypes.func.isRequired,
  mobileNumber: PropTypes.string.isRequired,
  externalErrors: PropTypes.object,
  restartLoginProcess: PropTypes.func.isRequired,
  resendVerificationCode: PropTypes.func.isRequired,
  incorrectNumber: PropTypes.func.isRequired,
};

export default withRouter(VerificationCodeEntry);
